<template>
  <!-- 表格表单基本模板 -->
  <div class="warpper" style="margin-right:0">
    <div class="content">
      <div class="searchBox clearfix">
        <div class="left">
          <my-form :formList="searchForm" ref="searchForm" span="6">
            <template
              v-for="(item,idx) in searchForm"
              :slot="item.slot"
              slot-scope="{ row, index,slots }"
            >
              <!--slot往外抛，由用户定义slot内容-->

              <slot :name="item.slot" :row="row" :index="index" :slots="slots"></slot>
            </template>
          </my-form>
        </div>
        <div class="right">
          <slot name="searchBtns" v-if="hasTargetSlot('searchBtns')"></slot>
          <Button
            type="primary"
            @click="()=>search()"
            v-if="!hasTargetSlot('searchBtns')||searchForm.lengthg>0"
          >查询</Button>
        </div>
      </div>
      <div class="btns" style="text-align:right;margin-bottom:20px;">
        <slot name="toolBtns" v-if="hasTargetSlot('toolBtns')"></slot>
      </div>
      <div class="tableBox setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableDate">
          <template v-for="(item,index) in columns" :slot="item.slot" slot-scope="{ row, index }">
            <!--slot往外抛，由用户定义slot内容-->
            <slot :name="item.slot" :row="{row,index}"></slot>
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page
          :total="total"
          :current="pageNo"
          :page-size="pageSize"
          show-total
          @on-change="pageChange"
          style="text-align: center"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * props:如下
 * apiUrl: 表格api地址
 * columns: 表格项数据配置，同iview的Table中的colums，参数一样
 * searchForm：表单配置，根据type不同渲染不同表单，当需要自定义时，使用render函数或者slot插槽来实现
 * emit 事件：
 * initSearch ： 当需要对搜索的数据进行自定义时，父组件中定义该事件，对参数进行处理
 *
 *
 */
import myForm from "@/components/commons/form";
let vm = this;
export default {
  components: { myForm },
  props: {
    apiUrl: {
      //表格接口地址
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    searchForm: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      analyList: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      //表单搜索字段
      tableDate: [],
      searchBase: []
    };
  },
  methods: {
    hasTargetSlot(target) {
      const obj = this.$slots[target];
      return !!obj;
    },
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList();
    },
    //搜索
    search(first) {
      this.$nextTick(() => {
        if (first) {
          this.pageNo = 1;
          this.$root.$children[0].isShowLoading = true;
          this.getList();
        } else {
          this.$refs.searchForm.validate((valid, obj) => {
            if (valid) {
              this.pageNo = 1;
              this.searchObj = obj;
              this.$root.$children[0].isShowLoading = true;
              this.getList();
            }
          });
        }
      });
    },
    async getList() {
      this.$root.$children[0].isShowLoading = true;
      this.$emit("initSearch", this.searchObj || {}); //可以让父组件对搜索条件进行自定义
      this.$http({
        url: this.apiUrl,
        data: {
          ...this.searchObj,
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.tableDate = res.data;
          this.total = res.total;
          this.$root.$children[0].isShowLoading = false;
        })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
    },
    init() {
      this.search(true);
    }
  },
  async mounted() {
    vm = this;
    this.init();
    console.log(this.$slots);
  }
};
</script>
<style lang="scss" scoped>
/deep/ .formGroup:after {
  display: none;
}

/deep/ .base {
  margin-top: 40px;
}

/deep/ .formGroup .title {
  font-size: 18px;
  color: #272933;
  margin-bottom: 0 !important;
  border-bottom: none !important;
}

/deep/ .ivu-form-item-content {
  color: #272933;
}

/deep/ .ivu-form-item {
  margin-bottom: 12px;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

/deep/ .ivu-tabs {
  margin-bottom: 20px;
}

/deep/ .ivu-page {
  margin-top: 20px;
}

/deep/ .formGroup {
  position: relative;

  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: "";
    filter: blur(5px);
    background: #fff;
  }

  padding: 0;

  .title {
    font-size: 16px;
    font-weight: bold;
    color: #3c464f;
  }
}

.detailModal {
  .detailBox {
    .title {
      flex-basis: 100%;
      font-size: 18px;
      margin: 40px 0;
      font-weight: bold;
      margin-bottom: 10px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 10px;
    }

    span {
      &:nth-child(1) {
        font-weight: bold;
      }
    }

    /deep/ .ivu-col {
      margin-top: 20px;

      .ivu-form-item-label {
        font-weight: bold;
      }
    }

    /deep/ .ivu-form-item {
      margin-bottom: 30px;
    }
  }
}

.searchBox {
  position: relative;

  .right {
    position: absolute;
    right: 0;
    top: 0;
  }
}

/deep/ .formGroup .ivu-col {
  width: 380px !important;
  margin-right: 20px;
}

.warpper {
  padding: 20px;
}

.addModal {
  /deep/ .formItem {
    display: flex;
    align-items: center;

    .ivu-form-item-label {
      width: 150px !important;
    }
  }

  /deep/ .ivu-form-item-content {
    flex: 1;
    margin-left: 0 !important;
    line-height: 40px;
  }

  /deep/ .ivu-col {
    width: 50% !important;
    margin-right: 0;
    margin-top: 5px;
  }

  /deep/ .ivu-form-item-error-tip {
    padding-top: 0;
  }

  /deep/ .ivu-col.block {
    width: 100% !important;
  }
}
.searchBox {
  display: flex;

  .left {
    width: auto !important;
  }

  .right {
    position: static;
  }
}

.editModal /deep/ .ivu-col span:nth-child(1) {
  margin-right: 6px;
}
</style>
